import { Navigate, useParams } from 'react-router-dom';

export function ProjectRedirect() {
  const { project } = useParams();
  return <Navigate to={`/browse/${project}`} replace />;
}

export default ProjectRedirect;
